import React from 'react'

import { DcoinsHistoryItem } from './DcoinsHistoryItem'
import { DateContainer } from './DcoinstHistory.styles'

export const DcoinsHistoryDay = ({ date, items }) => {
  console.log(items)
  return (
    <DateContainer isToday={date === 'Today'}>
      {date}
      {items.map(item => (
        <DcoinsHistoryItem key={item.createdAt} {...item} />
      ))}
    </DateContainer>
  )
}
